<template>
  <div class="idc-pub-wrap">
    <div class="idc-pub-wrapa">
      <div class="idc-pub-tit-wrap">
        <h2 class="idc-pub-maintit">MDC-Service 服务体系</h2>
        <p class="idc-pub-subtit">INTRODUCTION TO MDC</p>
      </div>
      <div class="idc-pub-wrapa-main wrap-main" data-aos="fade-up" data-aos-duration="1000">
        <img src="../../../assets/theresource/IDCPublic/pica.png" alt="MDC-Service 服务体系" />
      </div>
    </div>
    <div class="idc-pub-wrapb">
      <div class="idc-pub-tit-wrap">
        <h2 class="idc-pub-maintit">MDC-360° 自助管理平台</h2>
        <p class="idc-pub-subtit">MDC-360° SELF-SERVICE MANAGEMENT PLATFORM</p>
      </div>
      <div class="idc-pub-wrapb-main wrap-main">
        <div class="idc-pub-wrapb-textbox">
          <p>
            <span style="font-weight:600;">MDC-360° 旨在满足客户在MDC数据中心服务体验中的全生命周期需求。</span>
            以客户为中心，为用户提供极致体验，客户可利用浏览器或移动设备登录MDC-360°自助管理系统，轻松管理托管资产。除了提供数据中心360°全景视图，客户可以一键创建服务请求、故障单、整理订单、访问所有报告等。
          </p>
        </div>
        <div class="idc-pub-wrapb-pla">
          <div class="pla-center">MDC-360°</div>
          <div class="pla-item" style="top:60px;left:-20px" data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">
            <img
              src="../../../assets/theresource/IDCPublic/iconb1.png"
              style="width:74px;height:47px;"
            />
            <p>360°全景</p>
          </div>
          <div class="pla-item" style="top:160px;left:170px" data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000">
            <img
              src="../../../assets/theresource/IDCPublic/iconb2.png"
              style="width:44px;height:41px;"
            />
            <p>ERP系统</p>
          </div>
          <div class="pla-item" style="top:165px;right:420px" data-aos="fade-up" data-aos-delay="300" data-aos-duration="1000">
            <img
              src="../../../assets/theresource/IDCPublic/iconb3.png"
              style="width:44px;height:50px;"
            />
            <p>一键工单</p>
          </div>
          <div class="pla-item" style="top:145px;right:165px" data-aos="fade-up" data-aos-delay="400" data-aos-duration="1000">
            <img
              src="../../../assets/theresource/IDCPublic/iconb4.png"
              style="width:53px;height:50px;"
            />
            <p>客服咨询</p>
          </div>
          <div class="pla-item" style="top:60px;right:0px" data-aos="fade-up" data-aos-delay="500" data-aos-duration="1000">
            <img
              src="../../../assets/theresource/IDCPublic/iconb5.png"
              style="width:45px;height:47px;"
            />
            <p>自动报告</p>
          </div>
        </div>
      </div>
    </div>
    <div class="idc-pub-wrapc">
      <div class="idc-pub-tit-wrap">
        <h2 class="idc-pub-maintit">MDC-Standard 运维管理标准</h2>
        <p class="idc-pub-subtit">MDC-F OPERATION AND MAINTENANCE MANAGEMENT STANDARD</p>
      </div>
      <div class="idc-pub-wrapc-main wrap-main">
        <div class="idc-pub-wrapc-left" data-aos="fade-right"  data-aos-duration="1000">
          <p>架构 • 分布 • 容灾 • 监控</p>
          <p>组建选型 • 监控 • 容量 • 包管理 • 配置管理 • 测试工具</p>
          <p>OS/内核 • 初始化 • 用户/密码管理 • 基础agent</p>
          <p>机房 • 机柜 • 网段规划 • 容灾 • 波分 • 监控</p>
          <p>机型 • 命名 • 运营状态 • 重要级别 • 监控 • 资源池</p>
        </div>
        <div class="idc-pub-wrapc-right" data-aos="fade-left"  data-aos-duration="1000">
          <img
            src="../../../assets/theresource/IDCPublic/iconc1.png"
            style="width: 68px;height: 68px;"
          />
          <p>100位专家</p>
          <div class="line"></div>
          <img
            src="../../../assets/theresource/IDCPublic/iconc2.png"
            style="width: 64px;height: 64px;"
          />
          <p>7*24小时</p>
          <p>专业运维服务</p>
        </div>
      </div>
    </div>
    <div class="idc-pub-wrapd">
      <div class="idc-pub-tit-wrap">
        <h2 class="idc-pub-maintit">MDC-Customized 定制服务</h2>
        <p class="idc-pub-subtit">MDC-CUSTOMIZED SERVICE</p>
      </div>
      <div class="idc-pub-wrapd-main wrap-main" data-aos="fade-up"  data-aos-duration="1000">
        <div class="idc-pub-wrapd-item">
          <div class="itemd-img">
            <i class="iconfont icon-jigui"></i>
          </div>
          <div class="itemd-tit">机柜租赁/服务器托管</div>
          <div class="itemd-text">提供标准化的机架、带宽、IP和传输等整体的数据中心服务</div>
        </div>
        <div class="idc-pub-wrapd-item">
          <div class="itemd-img">
            <i style="font-size:90px" class="iconfont icon-zixun"></i>
          </div>
          <div class="itemd-tit">模块化定制</div>
          <div class="itemd-text">提供整座IDC或IDC模块的定制建设，根据需求设置制冷、空间、安防等系统</div>
        </div>
        <div class="idc-pub-wrapd-item">
          <div class="itemd-img">
            <i style="font-size:85px" class="iconfont icon-gongsi"></i>
          </div>
          <div class="itemd-tit" style="padding: 0 18px;">IDC建设与运营</div>
          <div class="itemd-text">提供IDC建设工程的咨询、设计及整体实施服务；同时数据中心进行整体运营管理</div>
        </div>
        <div class="idc-pub-wrapd-item">
          <div class="itemd-img">
            <i style="font-size:100px" class="iconfont icon-peizhi"></i>
          </div>
          <div class="itemd-tit" style="padding: 0 30px;">IDC运维外包</div>
          <div class="itemd-text">提供IDC运维外包服务，包括基础动力、机柜设备以及IT系统运维服务</div>
        </div>
      </div>
    </div>
    <div class="idc-pub-wrape">
      <div class="idc-pub-tit-wrap">
        <h2 class="idc-pub-maintit">MDC-Agent 代维服务</h2>
        <p class="idc-pub-subtit">MDC-AGENT MAINTENANCE SERVICE</p>
      </div>
      <div class="idc-pub-wrape-main wrap-main">
        <div class="idc-pub-wrape-item" v-for="(item,index) in itemsDataE" data-aos="fade-up" :data-aos-delay="item.delay"  data-aos-duration="1000">
          <img :src="item.img" />
          <p class="eitem-tit">{{item.tit}}</p>
          <p class="eitem-text" v-for="(subitem,subindex) in item.text">{{subitem}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      itemsDataE: [
        {
          img: require("../../../assets/theresource/IDCPublic/icone1.png"),
          tit: "客户服务",
          text: ["现场维护", "设备重启", "综合布线", "设备管理与检查", "参观服务"],
          delay: 150
        },
        {
          img: require("../../../assets/theresource/IDCPublic/icone2.png"),
          tit: "软件服务",
          text: ["内部检查", "系统安装", "系统配置", "设备破密", "软件安装", "数据备份"],
          delay: 300
        },
        {
          img: require("../../../assets/theresource/IDCPublic/icone3.png"),
          tit: "网络服务",
          text: ["故障排查", "端口操作", "连接与断网服务"],
          delay: 450
        },
        {
          img: require("../../../assets/theresource/IDCPublic/icone4.png"),
          tit: "硬件服务",
          text: ["硬件操作", "设备上下架", "RAID修复", "外设操作", "刻录光盘"],
          delay: 600
        },
        {
          img: require("../../../assets/theresource/IDCPublic/icone5.png"),
          tit: "增值服务",
          text: ["定制服务", "应急备件", "资产管理", "健康巡检", "拓扑绘制", "办公场地租赁"],
          delay: 750
        },
      ]

    }
  }


}
</script>
<style lang="less" scoped>
.idc-pub-wrap {
  .idc-pub-wrapa {
    padding-top: 80px;
    padding-bottom: 110px;
    .idc-pub-wrapa-main {
      padding-top: 65px;
      text-align: center;
      img {
        width: 1100px;
        height: 509px;
      }
    }
  }
  .idc-pub-wrapb {
    padding-top: 100px;
    padding-bottom: 120px;
    background: #fcf8f8;
    .idc-pub-wrapb-main {
      padding-top: 30px;
      .idc-pub-wrapb-textbox {
        width: 680px;
        height: 120px;
        margin: 0 auto;
        color: #fff;
        font-size: 14px;
        line-height: 26px;
        text-align: justify;
        padding: 20px 25px;
        background: #b81c22;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .idc-pub-wrapb-pla {
        margin: 0 auto;
        margin-top: 50px;
        width: 880px;
        height: 270px;
        position: relative;
        background-size: 880px 270px;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url("../../../assets/theresource/IDCPublic/picb.png");
        .pla-center {
          color: #333;
          font-size: 24px;
          position: absolute;
          top: 36px;
          left: 50%;
          transform: translateX(-55%);
        }
        .pla-item {
          position: absolute;
          img {
            margin-bottom: 10px;
          }
          p {
            color: #333;
            font-weight: 600;
            font-size: 18px;
          }
        }
      }
    }
  }
  .idc-pub-wrapc {
    padding-top: 90px;
    padding-bottom: 100px;
    .idc-pub-wrapc-main {
      width: 1000px;
      padding-top: 70px;
      display: flex;
      .idc-pub-wrapc-left {
        width: 720px;
        height: 380px;
        padding-left: 190px;
        padding-top: 15px;
        background-size: 720px 380px;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url("../../../assets/theresource/IDCPublic/picc.png");

        p {
          color: #333;
          font-size: 16px;
          font-weight: 600;
          line-height: 71px;
        }
      }
      .idc-pub-wrapc-right {
        padding-left: 60px;
        padding-top: 50px;
        .line {
          width: 70px;
          height: 1px;
          margin: 30px auto;
          background: #ccc;
        }
        p {
          color: #333;
          font-weight: 600;
          font-size: 22px;
          margin-top: 10px;
        }
      }
    }
  }
  .idc-pub-wrapd {
    padding-top: 90px;
    padding-bottom: 100px;
    background: #fcf8f8;
    .idc-pub-wrapd-main {
      width: 1080px;
      height: 430px;
      margin-top: 60px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .idc-pub-wrapd-item {
        width: 210px;
        height: 420px;
        transition: 0.3s;
        border: 1px solid #ccc;
        &:hover {
          height: 430px;
          background: #b81c22;
          border: 1px solid #b81c22;
          .itemd-tit,
          .itemd-text {
            color: #fff;
          }
          .itemd-img {
            i {
              color: #fff;
            }
          }
        }

        .itemd-img {
          width: 210px;
          height: 180px;
          text-align: center;
          i {
            color: #c13736;
            font-size: 80px;
            text-align: center;
            line-height: 180px;
          }
        }
        .itemd-tit {
          height: 58px;
          color: #c13736;
          font-size: 26px;
          padding: 0 40px;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .itemd-text {
          padding: 0 30px;
          color: #333;
          font-size: 16px;
          line-height: 28px;
          text-align: justify;
        }
      }
    }
  }
  .idc-pub-wrape {
    padding-top: 90px;
    padding-bottom: 100px;
    .idc-pub-wrape-main {
      padding-top: 60px;
      display: flex;
      justify-content: space-around;
      .idc-pub-wrape-item {
        width: 152px;
        color: #333;
        img {
          width: 152px;
          height: 165px;
        }
        .eitem-tit {
          font-size: 26px;
          font-weight: 600;
          padding: 20px 0 40px 0;
          position: relative;
          &:after {
            content: "";
            width: 40px;
            height: 2px;
            background: #b81c22;
            position: absolute;
            bottom: 12px;
            left: 50%;
            transform: translateX(-50%);
          }
        }
        .eitem-text {
          font-size: 18px;
          line-height: 32px;
        }
      }
    }
  }

  .idc-pub-tit-wrap {
    text-align: center;
    position: relative;
    .idc-pub-maintit {
      color: #3b3435;
      font-size: 28px;
    }
    .idc-pub-subtit {
      color: #ccc;
      font-size: 12px;
      position: absolute;
      left: 50%;
      top: -22px;
      transform: translateX(-50%) scale(0.8);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/resource/components/IDCPublic.vue